const modalCalendar = (state = {}, {type, payload}) => {
  switch (type) {
    case 'MODAL_CALENDAR.FETCH_EVENTS':
      return {...state, events: payload.events}
    case 'MODAL_CALENDAR.EVENT_SELECT':
      return {...state, selectedEventId: payload}
    default:
      return state
  }
}
  
export default modalCalendar
